import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { Team } from "../../entity";

export class GetAllTeamDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => Team)
  teams!: Team[];

  @Expose()
  @IsNumber()
  pageCount!: number;
}
